import React, { useState } from 'react';
import fr from 'facet-rest';
import {
  FDBox,
  FDDialog, FDDialogActions, FDDialogContent, FDDialogTitle,
  FDList, FDListItem, FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const metaOverrideSet = buildFacetDesignOverride();

const FQTmplQuestionAnswerOptions = ({ resource, attrName }) => {
  const { onSubmit } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const coll = resource.attr(attrName);
  const [loading, setLoading] = useState(false);
  const [currOption, setCurrOption] = React.useState(null);

  const handleSave = async () => {
    try {
      setLoading(true);
      await onSubmit();
    } catch (err) {
      displayErrorMessage(err, err.message || 'Failed to save answer option!');
    }
    setLoading(false);
  };

  return (
    <>
      <FDDialog
        open={!!currOption}
        onClose={() => setCurrOption(null)}
      >
        <FDDialogTitle value={'Configure Option'} />
        <FDDialogContent>
          <FDStack direction={'column'} spacing={2}>
            {currOption?.resource.meta().template().list().map((field) => {
              return (
                <MetaControl
                  key={field.attr('name')}
                  resource={currOption.resource}
                  metaOverrideSet={metaOverrideSet}
                  attrName={field.attr('name')}
                  onChange={(val) => {
                    setCurrOption(prev => ({
                      ...prev,
                      resource: currOption.resource.attr(field.attr('name'), val),
                    }));
                  }}
                />
              );
            })}
          </FDStack>
        </FDDialogContent>
        <FDDialogActions>
          <FDPrimaryActionButton
            label={'Submit'}
            disabled={loading}
            onClick={() => {
              if (currOption.idx === null) {
                resource.attr(attrName).resources().pushItem(null, currOption.resource);
              } else {
                resource.attr(attrName).resources().replaceAtIndex(currOption.idx, currOption.resource);
              }

              handleSave();
              setCurrOption(null);
            }}
          />
        </FDDialogActions>
      </FDDialog>
      <FDBox width={'100%'}>
        <FDStack direction={'column'} alignItems={'stretch'}>
          <FDStack justifyContent={'space-between'} alignItems={'center'}>
            <FDTitleText value={'Options'} />
            <FDPrimaryActionIconButton
              disabled={loading}
              icon={'add'}
              onClick={() => {
                setCurrOption({
                  resource: fr.resource({
                    attributes: {},
                    meta: resource.copy().meta().field(attrName).attr('arrayDef'),
                  }),
                  idx: null,
                });
              }}
            />

          </FDStack>
          <FDList>
            {coll.resources().list().map((optionRes, i) => {
              return (
                <FDListItem
                  key={i} // eslint-disable-line react/no-array-index-key
                  primaryText={`${optionRes.attr('label')} (${optionRes.attr('value')})`}
                  secondaryText={`Score: ${optionRes.attr('score')}`}
                  onClick={() => {
                    setCurrOption({ resource: optionRes.copy(), idx: i });
                  }}
                  secondaryActionIcon={'delete'}
                  secondaryAction={() => {
                    resource.attr(attrName).resources().removeItemByIndex(i);
                    handleSave();
                  }}
                />
              );
            })}
          </FDList>
        </FDStack>
      </FDBox>
    </>
  );
};

export { FQTmplQuestionAnswerOptions };
